import { apiService } from "@/api";


/**
 * 8. POST /program-phase/program/{program_id}
 */
export async function createProgramPhase(programId: string, payload: object) {
  const response = await apiService({
    url: `/program-phase/program/${programId}`,
    method: "post",
    protectedRoute: true,
    requestData: payload,
  });
  return response;
}

/**
 * 9. GET /program-phase/program/{program_id}
 */
export async function getProgramPhase(programId: string) {
  const response = await apiService({
    url: `/program-phase/program/${programId}`,
    method: "get",
    protectedRoute: true,
  });
  return response;
}